import CoreAside from './Aside.vue'
import CoreBreadcrumb from './Breadcrumb.vue'
import CoreCallout from './Callout.vue'
import CoreFooter from './Footer.vue'
import CoreHeader from './Header.vue'
import CoreSidebar from './Sidebar/Sidebar.vue'
import CoreSwitch from './Switch.vue'
import ListGroups from './ListGroups.vue'

export default {
  CoreAside,
  CoreBreadcrumb,
  CoreCallout,
  CoreFooter,
  CoreHeader,
  CoreSidebar,
  CoreSwitch,
  ListGroups
}



// WEBPACK FOOTER //
// ./src/components/core/index.js